import HttpInterceptor from 'core/http/HttpInterceptor';
import EventBus from 'core/EventBus';

export default class AbstractAuthHttpInterceptor
    extends HttpInterceptor {
  transform(options) {
    const headers = options.headers || {};
    const auxHeaders = this.headers || {};
    return { ...options, headers: { ...auxHeaders, ...headers } };
  }

  handleError({ execute, statusCode, data }) {
    switch(statusCode) {
      case 0:
        console.log('Publishing ServerDownEvent');
        EventBus.publish('ServerDownEvent', { execute });
        break;
      case 401:
        console.log('Publishing UnauthorizedEvent');
        EventBus.publish('UnauthorizedEvent', { execute });
        break;
    }

    return Promise.reject({ statusCode, data });
  }
}
